type ContactFormProfile = {
  countryId: number | null;
  stateId: number | null;
  contactRoleTypeId: number[];
  discProfileOptionId: number | null;
  salutationId: number | null;
};

type ContactDropdownSetters = {
  setActualCountry: (value: any) => void;
  setActualState: (value: any) => void;
  setActualRoleType: (value: any) => void;
  setActualDiscProfile: (value: any) => void;
  setActualSalutation: (value: any) => void;
};

export const useContactDropdownHandler = <T extends ContactFormProfile>(
  profile: T,
  setProfile: (profile: T) => void,
  setIsTouched: (touched: boolean) => void,
  setters: ContactDropdownSetters
) => {
  return (name: string, elem: any) => {
    setIsTouched(true);

    // Add extra logic here for dropdowns to keep update profile state
    if (name === "countryId") {
      setters.setActualCountry(elem);
      setProfile({
        ...profile,
        countryId: elem.value,
      });
    }
    if (name === "stateId") {
      setters.setActualState(elem);
      setProfile({
        ...profile,
        stateId: elem.value,
      });
    }
    if (name === "contactRoleTypeId") {
      setters.setActualRoleType(elem);
      setProfile({
        ...profile,
        contactRoleTypeId: elem.map((role) => role.value),
      });
    }
    if (name === "discProfileOptionId") {
      setters.setActualDiscProfile(elem);
      setProfile({
        ...profile,
        discProfileOptionId: elem.value,
      });
    }
    if (name === "salutationId") {
      setters.setActualSalutation(elem);
      setProfile({
        ...profile,
        salutationId: elem.value,
      });
    }
  };
};
